/**
 * 项目默认配置项
 */
export default {
  title: '米其林商城',
  iconfontUrl: '',
  production: process.env.NODE_ENV === 'production' && process.env.VUE_APP_PREVIEW !== 'true'
}
